@if (label) {
	<div class="c-input__label-container" [ngClass]="{ 'cdk-visually-hidden': hideLabel }">
		<label class="c-input__label" [ariaHidden]="!hideLabel" [attr.for]="inputId">
			{{ label }}
			@if (isOptional && showOptionalLabel) {
				&nbsp;<small class="c-input__label__optional">{{
					i18nKeys.FormLabels.OptionalMarker | translate
				}}</small>
			}
		</label>

		@if (tooltip) {
			<cjm-info class="u-margin-top-xs u-margin-left-sm" tooltipPosition="right" [description]="tooltip" />
		}
	</div>
}
@if (hint) {
	<div class="c-input__hint">{{ hint }}</div>
}

<ng-content></ng-content>

<div class="c-input__description" cypressTag="General.Input.Error" [ngClass]="{ 'is-error': hasError }">
	<ng-content select="[description]"></ng-content>
</div>
